import React, {useEffect} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";

import {errorBox_Show} from "../../../../actions/A_Popups";
import SvgIcons from "../../../Icons/SvgIcons";
import {setNewFeatureGroupImage, toggleFeatureGroupImagePopup} from "../../../NewScope/newScopeActions";
import {getIconStyles} from "../../../../utilities/iconSizes";

const WizardPopupEditCustomIconUploadButton = (props) => {

  const {intl, toggleFeatureGroupImagePopup, newFeatureGroupImage, setNewFeatureGroupImage} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);

  const {wizardGroupIcon} = wizardPopupState;

  useEffect(() => {
    if (newFeatureGroupImage) {
      wizardPopupDispatch({
        type: wizardPopupAction,
        payload: {
          wizardGroupIcon: newFeatureGroupImage
        }
      })
      setNewFeatureGroupImage(null)
    }
  }, [newFeatureGroupImage]);

  const uploadIconButtonClick = () => {
    toggleFeatureGroupImagePopup({
      image: wizardGroupIcon,
      newFeatureGroup: true,
    })
  }

  const removeThumbnailClick = () => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        wizardGroupIcon: "",
      }
    })
  };

  return (
    <div className="wizard-upload">
      <div className={"wizard-upload__button wizard-upload__button" + (wizardGroupIcon ? " wizard-upload__button--with-icon" : "")}
             onClick={uploadIconButtonClick}
             style={wizardGroupIcon
               ? getIconStyles(wizardGroupIcon)
               : null}>
        {wizardGroupIcon
          ? null
          : <FormattedMessage id="wizard.popup.iconUploadButton"/>}
      </div>
      {wizardGroupIcon ? (
        <button className="wizard-group__icon ui-icon-gray2 ui-icon-gray2--red" onClick={removeThumbnailClick}>
          {SvgIcons.closeRed}
        </button>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupGroup} = store.wizardState;
  const {newFeatureGroupImage} = store.newScope;
  return {
    wizardPopupGroup,
    newFeatureGroupImage,
  };
};

const mapDispatchToProps = {
  toggleFeatureGroupImagePopup,
  setNewFeatureGroupImage,
  errorBox_Show
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardPopupEditCustomIconUploadButton)
)
